import { Icon, IconColor, IconName } from 'common/components/controls';
import { forNamespace } from 'common/lib/util/i18n';
import * as React from 'react';
import styles from './out-of-free-team-boards.less';

const format = forNamespace('out of free team boards', {
  shouldEscapeStrings: false,
});

interface OutOfFreeTeamBoardsProps {
  shouldShowFeedbackLink?: boolean;
}

const OutOfFreeTeamBoards = ({
  shouldShowFeedbackLink,
}: OutOfFreeTeamBoardsProps) => {
  const text = {
    title: format('this team has reached the maximum number of open boards'),
    summary: format('upgrade to business class and get'),
    unlimitedTeamBoards: format('unlimited team boards'),
    powerfulAdminTools: format('powerful admin tools'),
    unlimitedPowerUps: format('unlimited power-ups'),
    collectionsToOrganizeBoards: format('collections to organize boards'),
  };

  return (
    <div className={styles.ooftbContainer}>
      <div className={styles.ooftbText}>
        <div className={styles.title}>{text.title}</div>
        <p>{text.summary}</p>
        <ul>
          <li>
            <Icon name={IconName.Board} color={IconColor.Blue} />{' '}
            <span className={styles.liText}>{text.unlimitedTeamBoards}</span>
          </li>
          <li>
            <Icon name={IconName.Admin} color={IconColor.Green} />{' '}
            <span className={styles.liText}>{text.powerfulAdminTools}</span>
          </li>
          <li>
            <Icon name={IconName.PowerUp} color={IconColor.Pink} />{' '}
            <span className={styles.liText}>{text.unlimitedPowerUps}</span>
          </li>
          <li>
            <Icon name={IconName.Collection} color={IconColor.Purple} />{' '}
            <span className={styles.liText}>
              {text.collectionsToOrganizeBoards}
            </span>
          </li>
        </ul>
        {shouldShowFeedbackLink ? (
          <div className={styles.feedbackLinkContainer}>
            <a
              className={styles.feedbackLink}
              href="https://trello.typeform.com/to/FhilOt"
              target="_blank"
              rel="noopener noreferrer"
            >
              {format('feedback')}
            </a>
          </div>
        ) : null}
      </div>
      <div className={styles.ooftbImage} />
    </div>
  );
};

export default OutOfFreeTeamBoards;



// WEBPACK FOOTER //
// ./app/common/components/create-board/out-of-free-team-boards.tsx